module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-BOOSTER-GREEN-4.bb8d22c3.jpg";